import http from 'plugins/axios';

export default {
  enums() {
    return http.get({ url: '/ta/admin/tenant/vip/rate/enums' });
  },
  page({ page, size }) {
    return http.get({ url: `/ta/admin/tenant/vip/rate/page?page=${page}&size=${size}` });
  },
  update(data) {
    return http.post({ url: '/ta/admin/tenant/vip/rate/update', data });
  },
  history({ vipLevelId, page, size }) {
    return http.get({
      url: `/ta/admin/tenant/vip/rate/history?vipLevelId=${encodeURIComponent(vipLevelId)}&page=${page}&size=${size}`,
    });
  },
};
